import { Slugs } from "../enums/slugs.enum";
import { ENV_GATSBY_MATRIX_BASE_URL } from "./secrets";

export const getNewsArticleUrl = (id: number) => {
  return `/${Slugs.NEWS}/${Slugs.ARTICLE}/${id}`;
};

export const getMatrixHomeUrl = () => {
  return `${ENV_GATSBY_MATRIX_BASE_URL}/app/applications`;
};